export const socketDataTypes = {
    INPUT_PROMPT: 'input_prompt',
    OUTPUT: 'output',
    STDERR: 'stderr',
    ERROR: 'error',
    EXECUTED: 'executed',
}